module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-bottom-stone-path-background-remnants.c1a5d3e7.png";